import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { RootState } from "redux/rootReducer";
import { HOME_PATH } from "Routes/paths";

interface UserProtectedRoutesProps {
  children: React.ReactNode;
}

const UserProtectedRoutes = ({ children }: UserProtectedRoutesProps) => {
  const navigate = useNavigate();
  const { loginData } = useSelector((state: RootState) => state.loginReducer);

  useEffect(() => {
    if (loginData === null) {
      navigate(HOME_PATH);
      return;
    }
  }, [loginData]);
  return <div>{children}</div>;
};

export default UserProtectedRoutes;
